import { formatMoney, parserMoney } from "@Utils/Functions";
import { useContext, useEffect, useState } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { firstLetterToUppercase } from "src/utils/Functions"
import { getSurfaceRange } from "../options";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";

export const RangeMetersFilters = () => {
	const { filters } = useFilters();
	const { country_code, translations } = useContext(ConfigStateContext);
	const surfaceRange = country_code !== "CO" ? getSurfaceRange(translations) : [];
	const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const [minM2, setMinM2] = useState('');
    const [maxM2, setMaxM2] = useState('');

    useEffect(() => {
        if (filters?.m2Min) {
            setMinM2(filters?.m2Min);
        } else {
            setMinM2("");
        }

        if (filters?.m2Max) {
            setMaxM2(filters?.m2Max);
        } else {
            setMaxM2("");
        }
    }, [filters.m2Min, filters.m2Max])

    const formatMetersRange = (e, type) => {
		const inputNum = e.target && e.target.value ? e.target.value.replace(/\D/g, '') : ''
		const formattedNum = formatMoney(inputNum);

        if (type === "max") setMaxM2(formattedNum);
        else setMinM2(formattedNum)
	}

    const handleMinM2Change = () => {
        if (minM2 && minM2 !== "") {
            changeFilters({ m2Min: { text: `Desde ${formatMoney(minM2)}m²`, value: parserMoney(minM2) } });
        } else {
            changeFilters({ m2Min: null });
        }
    }

    const handleMaxM2Change = () => {
        if (maxM2 && maxM2 !== "") {
            changeFilters({ m2Max: { text: `Hasta ${formatMoney(maxM2)}m²`, value: parserMoney(maxM2) } });
        } else {
            changeFilters({ m2Max: null });
        }
    }

    const handleRadioOnChange = (value: string | number) => {
		changeFilters({ m2Type: { text: undefined, value: value } })
    }

    const clearValue = async (setValue, value) => {
        await setValue('');
        if (filters[value]) {
            changeFilters({ [value]: undefined })
        }
    }

    return (
        <div className="otherFilters__container" id="rangeMeters">
            <p>{firstLetterToUppercase(translations.area)}</p>

            {surfaceRange?.map((val, i) => {
                return (
                    <div key={'rangeMeters - ' + i} className="otherFilters__container__option">
                        <input
                            type="radio"
                            className='radioCustomInput'
                            name="rangeMeters"
                            id={val.text}
                            onClick={() => handleRadioOnChange(val.value)}
                            defaultChecked={
                                filters?.m2Type ?
                                    filters?.m2Type === val.value : 
                                    false
                            }
                        />
                        <label htmlFor={val.text}>{val.text}</label>
                    </div>
                )
            })}

            <div className="otherFilters__container__range">
                <div className="priceRangeFilter__range__box">
                    <input
                        type="text"
                        className="priceRangeFilter__range__input boxCustomInput"
                        placeholder="Min m²"
                        onChange={(e) => formatMetersRange(e, "min")}
                        onBlur={handleMinM2Change}
                        value={formatMoney(minM2)}
                    />
                    {minM2 && <button onClick={() => clearValue(setMinM2, "m2Min")} className="clear-button">X</button>}
                </div>
                -
                <div className="priceRangeFilter__range__box">
                    <input
                        type="text"
                        className="priceRangeFilter__range__input boxCustomInput"
                        placeholder="Max m²"
                        onChange={(e) => formatMetersRange(e, "max")}
                        onBlur={handleMaxM2Change}
                        value={formatMoney(maxM2)}
                    />
                    {maxM2 && <button onClick={() => clearValue(setMaxM2, "m2Max")} className="clear-button">X</button>}
                </div>
            </div>

            {(minM2 && maxM2 && minM2 > maxM2) ?
                <p className="errorMessage">
                    El valor mínimo no puede ser mayor al máximo
                </p> :
                <></>
            }
        </div>
    )
}